import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price) {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
  }).format(price);
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function formatTime(timeString) {
  // British format: 24-hour time (e.g., "19:00")
  const [hours, minutes] = timeString.split(':');
  return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
}

export const DAYS_OF_WEEK = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const CATEGORIES = [
  { value: 'ballet', label: 'Ballet', color: 'bg-pink-100 text-pink-800' },
  { value: 'contemporary', label: 'Contemporary', color: 'bg-purple-100 text-purple-800' },
  { value: 'jazz', label: 'Jazz', color: 'bg-blue-100 text-blue-800' },
  { value: 'hip_hop', label: 'Hip Hop', color: 'bg-orange-100 text-orange-800' },
  { value: 'tap', label: 'Tap', color: 'bg-amber-100 text-amber-800' },
  { value: 'drama', label: 'Drama', color: 'bg-red-100 text-red-800' },
  { value: 'musical_theatre', label: 'Musical Theatre', color: 'bg-indigo-100 text-indigo-800' },
  { value: 'singing', label: 'Singing', color: 'bg-teal-100 text-teal-800' },
  { value: 'piano', label: 'Piano', color: 'bg-slate-100 text-slate-800' },
  { value: 'violin', label: 'Violin', color: 'bg-emerald-100 text-emerald-800' },
  { value: 'guitar', label: 'Guitar', color: 'bg-yellow-100 text-yellow-800' },
];

export function getCategoryInfo(category) {
  return CATEGORIES.find(c => c.value === category) || { value: category, label: category, color: 'bg-gray-100 text-gray-800' };
}


/**
 * Get the effective price for a class based on priority:
 * 1. six_week_price (if set) - preferred for 6-week billing
 * 2. term_price (if set) - fallback for term-based billing
 * 3. subscription_price (if set) - for monthly billing
 * 4. one_off_price (if set) - for single class pricing
 * @returns {object|null} { price: number, label: string, type: string }
 */
export function getClassPrice(classData) {
  if (classData.six_week_price) {
    return { price: classData.six_week_price, label: 'Per 6 weeks', type: 'six_week' };
  }
  if (classData.term_price) {
    return { price: classData.term_price, label: 'Per term', type: 'term' };
  }
  if (classData.subscription_price) {
    return { price: classData.subscription_price, label: 'Per month', type: 'subscription' };
  }
  if (classData.one_off_price) {
    return { price: classData.one_off_price, label: 'Per class', type: 'one_off' };
  }
  return null;
}

/**
 * Get the billing price amount for a class (prioritizes 6-week over term)
 * @returns {number} The price amount
 */
export function getClassBillingPrice(classData) {
  return classData.six_week_price || classData.term_price || classData.subscription_price || classData.one_off_price || 0;
}
